import Http from './http';

// 用户模块
export const userRes = new Http('user', {
    login(params) {
        return this.post('login', params);
    },
    logout(){
        return this.post('logout')
    },
    getList(params) {
        return this.get('list', params);
    },
    register(param) {
        return this.post('regist', param);
    },
    forgetPwd(param) {
        return this.post('forgetPwd', param);
    },
    getUserInfo(params) {
        return this.get('detail', params);
    },
    updatePwd(param) {
        return this.post('updatePwd', param);
    },
    enrolApply(param) {
        return this.post('enrol/apply', param);
    },
    getEnrolPage(param) {
        return this.get('enrol/page', param);
    },
    // 报考审查列表
    getEnrolVerifyPage(param) {
        return this.get('enrol/verify/page', param);
    },
    // 审查报名
    approvalEnrolVerify(param) {
        return this.post('enrol/verify/approval', param);
    },
    // 批量审查
    approvalBatchEnrolVerify(param) {
        return this.post('enrol/verify/approvalBatch', param);
    },
    queryEnrolVerifyList(param) {
        return this.get('enrol/verify/list', param);
    },
    // 发送审查通知(整个招考全部发送)
    sendApprovalNotify(param) {
        return this.post('enrol/verify/sendApprovalNotify', param);
    },
    // 发送审查通知(单个/批量发送)
    sendApprovalNotifyBatch(param) {
        return this.post('enrol/verify/sendApprovalNotifyBatch', param);
    },
    setEnrolVerifyEdit(param) {
        return this.post('enrol/verify/setEdit', param);
    },
    // 查看准考证信息
    getExamCard(param) {
        return this.get('enrol/getExamCard', param);
    },
    // 导出审查记录
    exportVerify(param) {
        return this.downloadFile('enrol/verify/exportVerify', param);
    },
    // 导入审查记录
    importVerify(param) {
        return this.upload('enrol/verify/importVerify', param);
    },
    // 导出报名表
    exportEnrolWord(params) {
        return this.post('enrol/exportEnrolWord', params,true,{timeout:50000});
    }
});

export const confirmRes = new Http('confirm', {
    list(params) {
        return this.get('page', params);
    },
    delete(params) {
        return this.post;
    }
});
export const commonRes = new Http('common', {
    getEmailCaptcha(param) {
        return this.post('emailCaptcha', param);
    }
});
export const notifyRes = new Http('notify', {
    getPage(param) {
        return this.get('page', param);
    },
    getDetail(param) {
        return this.get('view', param);
    },
    getList(param) {
        return this.get('list', param, false);
    }
});

export const recruitRes = new Http('exam', {
    getList(params) {
        return this.get('list', params);
    },
    getPage(params) {
        return this.get('page', params);
    },
    save(params) {
        return this.post('save', params);
    },
    getDetail(params) {
        return this.get('detail', params);
    },
    release(params) {
        return this.post('release', params);
    },
    deleteRecruit(params) {
        return this.delete('delete', params);
    },
    getPostList(params) {
        return this.get('post/list', params,false);
    },
    savePost(params) {
        return this.post('post/save', params);
    },
    postCanEdit(params) {
        return this.get('post/isEdit', params);
    },
    getTemplateFields(params) {
        return this.get('getEnrolData', params);
    },
    addExtraFields(params) {
        return this.post('saveEnrolData', params);
    },
    deleteExtraFields(params) {
        return this.post('removeEnrolData', params);
    },
    // 招考信息列表
    getListForQuery(param) {
        return this.get('listForQuery', param);
    },
    getEnablePostList(params) {
        return this.get('post/enablelist', params);
    },
    getEnableDetail(params) {
        return this.get('isEnable', params);
    },
    // 招考环节列表
    getStepList(param) {
        return this.get('step/list', param);
    },
    // 成绩分页列表
    getAchievementPage(param) {
        return this.get('achievement/page', param);
    },
    // 成绩导入
    importAchieveExcel(param) {
        return this.upload('achievement/importAchieveExcel', param);
},
    importAchieveExcel(param){
        return this.upload('achievement/importAchieve',param)
    },
    //成绩模板表导出
    exportAchieveTmpl(param) {
        return this.downloadFile('achievement/exportAchieveTmpl', param);
    },
    // 成绩导出
    exportAchieve(param){
        return this.downloadFile('achievement/exportAchieve',param)
    }

});
export const examineeRes = new Http('user/enrol', {
    apply(params) {
        return this.post('apply', params);
    },
    getApplyDetail(params) {
        return this.get('detail', params);
    },
    // 导出座签表
    exportSeatMore(data){
        return this.downloadFile('exportSeatMore',data)
    },
    // 导出签到表
    exportSignMore(param){
        return this.downloadFile('exportSignMore',param)
    },
    // 导出学生信息表
    exportExamineeMore(param){
        return this.downloadFile('exportExamineeMore',param)
    }
});

export const postRes = new Http('exam/address', {
    getPage(params) {
        return this.get('page', params);
    },
    savePoint(params) {
        return this.post('save', params);
    },
    exportExamAddressTmpl(params) {
        return this.downloadFile('exportExamAddressTmpl', params);
    },
    importExamAddress(params) {
        return this.upload('importExamAddress', params);
    },
    deletePost(params) {
        return this.delete('delete', params);
    },
    getList(param){
        return this.get('list',param)
    }
});

export const roomRes = new Http('examPlace', {
    getList(params) {
        return this.get('list', params);
    },
    saveRoom(params) {
        return this.post('save', params);
    }
});

export const adminRes = new Http('admin/user', {
    getPage(params) {
        return this.get('page', params);
    },
    saveAdmin(params) {
        return this.post('save', params);
    },
    deleteAdmin(params) {
        return this.delete('delete', params);
    },
    resetPass(params) {
        return this.post('resetPwd', params);
    }
});
// 考试信息相关
export const examineeInfoRes = new Http('examinee', {
    createExamEnum(param) {
        return this.post('genExamEnum', param,true,{timeout:50000});
    },
    // 获取考试注意事项
    getExamEnumNote(param) {
        return this.get('note', param);
    },
    genExamEnumValid(param){
        return this.post('genExamEnumValid',param)
    }
});

//成绩管理
export const achievementRes = new Http('exam/achievement', {
    getPage(params) {
        return this.get('page', params);
    },
    confirmNextStep(params) {
        return this.post('confirmNextStep', params);
    },
    sendAchievementNotify(param){
        return this.post('sendAchievementNotify',param)
    }
});
// 统计模块
export const analysisRes = new Http('analysis',{
    getAnalysisCount(param){
        return this.get('count',param)
    }
})